import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DrawIcon(props: IconProps) {
    return <Icon {...props} iconKey={"draw"}/>
}
